import React, { useState, useEffect } from "react";
import Modal from "../../common/Modal/Modal";
import { SaveCSV } from "../../csv/SaveCSVForLater";
import { useNavigate, useOutletContext } from "react-router-dom";
import Papa from "papaparse";
import { retrieveData, formatCSVData } from "../../csv/JSONtoCSV";
import { generateNameIfNoInputtedName } from "../../snapshots/NewSnapshot/GenerateFileName";

export default function SaveForLaterModal({disabled}) {
  // Initialise Use States
  const [openModal, setOpenModal] = useState(false);
  const [inputtedFileName, setInputtedFileName] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);

  useEffect(() => {
    getS3().then(setS3);
  }, [])

  // redirect user to snapshots pager after saving file
  const goBacktoSnapshots = () => {
    localStorage.removeItem("companyNameEditable");
    localStorage.removeItem("formattedDataArray");
    localStorage.removeItem("UpdatedDataArray");
    localStorage.removeItem("companyName");
    localStorage.removeItem("timestamp");
    navigate("/snapshots");
  };

  // Initialise Variables
  const initialFileName = localStorage.getItem("initialFileName");

 // Modal Handling Functions
 const handleOpenModal = () => {
  setOpenModal(true);
};

const handleCloseModal = () => {
  if (isSuccess === true) {
    goBacktoSnapshots();
  } else if (isError === true) {
    if (errorMessage === "Duplicate Error") {
      // If the error message is a duplicate error, reload the modal
      handleReloadModal();
    } else {
      // If it's any other error message, simply close the modal
      setOpenModal(false);
    }
  } else {
    setOpenModal(false);
  }
  setIsError(false);
  setIsSuccess(false);
};

const handleReloadModal = () => {
  setIsError(false);
};

  // Input Handling
  const handleInputChange = (event) => {
    setInputtedFileName(event.target.value);
    setIsError(false); // Clear the error message when input changes
  };

  // Save Functionality Handling
  const handleSaveForLater = async () => {
    try {

      //Check if the name exists and format it according to specifics (depending if it's RepX/regular Snapshot file)
      const generatedNewName = generateNameIfNoInputtedName(initialFileName, inputtedFileName, setInputtedFileName, false);
      localStorage.setItem("selectedSnapshot", generatedNewName);

      // Create the CSV string when csvData changes
      const csvData = await retrieveData();
      const formattedCSVData = formatCSVData(csvData);
      const csvString = Papa.unparse(formattedCSVData);
      await SaveCSV(S3, initialFileName, generatedNewName, csvString);
      setIsSuccess(true);
      goBacktoSnapshots();
    } catch (error) {
      setIsError(true);
      if (error.message === "UploadError") {
        setErrorMessage("There was an error during the upload of the report. Please try again later.");
      } else if (error.message === "DuplicateError") {
        setErrorMessage("There is another snapshot with the same name already exists. Please try another name.");
      } else {
        setErrorMessage(error.message);
      }
    }
  };

  return (
    <>
      {/* Save button on Input Form Page */}
      <button disabled={disabled} className={disabled ? "disabled-button":"orange-button"} style={{width: 128}} onClick={handleOpenModal}>
        Save for Later
      </button>
      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={"Save CSV For Later"}
        showCustomContent={true}
        customContent={
          isSuccess ? (
            // If submits successfully to S3
            <>
              <div className="modal-success-container">
                <div className="icon-container">
                  <i className="fas fa-check" />
                </div>
                <p className="success-message">
                  You have successfully saved your snapshot!
                </p>
              </div>
              <button className="button-close" onClick={handleCloseModal}>
                Okay
              </button>
            </>
          ) : isError ? (
            //   It submits unsuccessfully
            <>
              <div className="error-message">{errorMessage}</div>
              <div>
                <button
                  className="button-close"
                  // onClick={handleCloseModal}
                  onClick={handleReloadModal}
                >
                  Close
                </button>
              </div>
            </>
          ) : (
            // Default state -> No success & no error
            <>
              <p className="savesubmitmodal-description">
                Save your progress and resume later.
              </p>
              <div className="modal-input-container">
                <input
                  value={inputtedFileName}
                  onChange={handleInputChange}
                  placeholder={initialFileName}
                />
              </div>
              <div className="button-close-container">
                <button className="button-close" onClick={handleSaveForLater} style={{fontSize: "14px", width: "72px", height: "38px"}}>
                  Save
                </button>
              </div>
            </>
          )
        }
      />
    </>
  );
}